module.exports = __webpack_public_path__ + "img/button_download_windows.069390d8.png";